module.exports = __webpack_public_path__ + "static/img/companyProfileBanner.17ff62b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companyProfileBanner.png
// module id = geg/
// module chunks = 2